<script lang="ts">
	import { format } from 'svelte-i18n';
	import { onMount } from 'svelte';
	import { AdvancedCardV2, ButtonV2, LabelListV2 } from '@Shelly/shelly-design-system/index';
	import { percent_from_value_range } from 'src/helpers/utilities';
	import {
		DEFAULT_MIN_CLASSIFICATION_SCORE,
		getCameraCloudSettings,
	} from 'src/services/cam-cloud/recordings';
	import DetectionConfidenceModal from './DetectionConfidenceModal.svelte';

	export let deviceId: string;

	const SCORE_RANGE = [0, 1];

	/** The stored threshold, read up-front for the card label; null until known. */
	let percent: number | null = null;
	let showModal = false;

	$: title = $format('camera_cloud_confidence_title', { default: 'AI Detection confidence' });
	$: confidenceLabels =
		percent === null ? [] : [{ id: 'confidence', icon: 'fal fa-tag', value: `${percent}%` }];

	/* An unreadable value stays null; the modal reads it again when opened. */
	const loadPercent = async () => {
		if (!deviceId) return;

		try {
			const settings = await getCameraCloudSettings(deviceId);
			percent = percent_from_value_range(
				settings?.minClassificationScore ?? DEFAULT_MIN_CLASSIFICATION_SCORE,
				SCORE_RANGE,
			);
		} catch (error) {
			console.log('Failed to load detection confidence', error);
		}
	};

	const handleAdjust = () => {
		showModal = true;
	};

	const handleClose = () => {
		showModal = false;
	};

	onMount(loadPercent);
</script>

<AdvancedCardV2
	class="mb-s"
	aria-label={title}
	{title}
	avatar={{ icon: 'fal fa-sparkles' }}
	subtitle={{
		type: 'muted',
		bold: false,
		textSmall: true,
		value: $format('camera_cloud_confidence_desc', {
			default: 'Minimum confidence required to mark an object.',
		}),
	}}
>
	<LabelListV2
		slot="main"
		size="s"
		labelList={confidenceLabels}
		a11yProps={{ isInteractive: false }}
	/>
	<div slot="right" class="d-flex align-items-center">
		<ButtonV2
			size="s"
			variant="secondary"
			on:click={handleAdjust}
			aria-label={$format('camera_cloud_confidence_manage', { default: 'Adjust' })}
		>
			{$format('camera_cloud_confidence_manage', { default: 'Adjust' })}
		</ButtonV2>
	</div>
</AdvancedCardV2>

<DetectionConfidenceModal {deviceId} {showModal} bind:percent on:close={handleClose} />
